import type { Theme } from '@mui/material';

export const styles = {
  headerColumn: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  backLinkWrapper: {
    display: 'flex',
    alignItems: 'center',
  },

  loadingIndicator: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  meta: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    py: 1,
  },

  buttons: {
    marginTop: '1.5rem',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
  },

  permissionsContainer: (theme: Theme) => ({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    margin: '1.25rem -0.625rem',

    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-start',
    },
  }),

  permissionsBox: {
    margin: '0.625rem',
  },

  userSettingsBoxHeader: (theme: Theme) => ({
    backgroundColor: theme.colors.neutral[50],
    height: '2.5rem',
    borderTop: '0.125rem solid',
    borderLeft: '0.125rem solid',
    borderRight: '0.125rem solid',
    borderRadius: '0.5rem 0.5rem 0 0',
    borderColor: theme.colors.neutral[200],
  }),
  userSettingsBox: (theme: Theme) => ({
    backgroundColor: theme.colors.white,

    borderBottom: '0.125rem solid',
    borderLeft: '0.125rem solid',
    borderRight: '0.125rem solid',

    borderRadius: '0 0 0.5rem 0.5rem',
    borderColor: theme.colors.neutral[200],
    justifyContent: 'center',
    alignItems: 'center',
  }),
  divider: (theme: Theme) => ({
    border: '0.063rem solid',
    borderColor: theme.colors.neutral[200],
  }),

  saveAndCancelButtons: (theme: Theme) => ({
    mt: '1rem',
    px: '0.75rem',
    py: '1rem',
    border: '0.125rem solid',
    borderColor: theme.colors.neutral[200],
    borderRadius: '0.5rem',
  }),
};
